import React, { useEffect, useState } from 'react';
import MenuReadView from './MenuReadView';
import MenuCreator from './MenuCreator';

// mui
import { Typography, Button, Divider } from '@mui/material';

// services
import { removeMenu } from '../../../services/kitchenService';
import { useAuth } from '../../../AuthContext';
import { useLocale } from '../../../i18n/LanguageContext';


export default function KitchenMenus(props) {
  const { auth } = useAuth();
  const { t } = useLocale();
  const [error, setError] = React.useState(false);

  function handleMenuChange(menu) {
    var existingMenus = props.kitchenData.menus;
    const pos = existingMenus.map(m => m.id).indexOf(menu.id);
    existingMenus[pos] = menu;
    props.onDataChange({...props.kitchenData, menus: existingMenus});
  }

  function handleNewMenu(menu) {
    var existingMenus = props.kitchenData.menus? props.kitchenData.menus : [];
    existingMenus.push(menu);
    props.onDataChange({...props.kitchenData, menus: existingMenus});
  }

  function handleRemoveMenu(menuId) {
    removeMenu(menuId, auth).then((removed) => {
      if (removed) {
        var existingMenus = props.kitchenData.menus;
        const pos = existingMenus.map(m => m.id).indexOf(menuId);
        if (pos > -1) {
          existingMenus.splice(pos, 1); // remove element in memory
          props.onDataChange({...props.kitchenData, menus: existingMenus});
        }
      } else {
        setError(true);
      }
    }).catch(() => {
      setError(true);
    });
  }

  const noExistingMenus = (
    <div>
        <Typography variant='h5'>{t('kitchenMenus.title')}</Typography>
        <div style={{ marginBottom: 16 }}>{t('kitchenMenus.emptyState')}</div>
        <MenuCreator 
          kitchenId={props.kitchenData.id} 
          onMenuCreation={handleNewMenu}
        />
    </div>
  );

  if (!props.kitchenData || !props.kitchenData.menus || props.kitchenData?.menus?.length === 0) {
    return noExistingMenus;
  }

  return (
    <div>
      {props.kitchenData.menus.map((menu, index) => (
        <React.Fragment key={menu.id}>
            <MenuReadView 
              key={menu.id} 
              menu={menu}
              menuNumber={index + 1}
              chef={props.kitchenData.chef}
              onMenuChange={handleMenuChange}
              onRemoveMenu={handleRemoveMenu}
              errorOnRemove={error}
            />
            <Divider style={{ margin: '24px 0' }} />
        </React.Fragment>
      ))}

      <div style={{ marginBottom: 16 }}>{t('kitchenMenus.createPrompt')}</div>

      <MenuCreator 
        kitchenId={props.kitchenData.id}
        onMenuCreation={handleNewMenu}
      />
    </div>
  );
}